import { baseShadowStyle } from '../../../../shared/style/base-shadow';
import { COLORS } from '../../../../shared/config/colors/colors';
import { styled } from 'goober';

export const Content = styled('div')`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`;

export const Controls = styled('div')<{ isShow: boolean }>`
    display: flex;
    gap: 10px;
    opacity: 0;
    pointer-events: none;
    ${({ isShow }) =>
        isShow &&
        `
        opacity: 1;
        pointer-events: unset;
    `}
`;

export const Wrapper = styled('div')`
    display: flex;
    padding: 20px;
    gap: 20px;
    border-radius: 20px;
    background-color: ${COLORS.neutral_00};
    align-items: flex-start;
    ${baseShadowStyle};
`;

export const Title = styled('div')`
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    gap: 4px;
`;

export const Info = styled('div')`
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    gap: 8px;
`;

export const Footer = styled('div')`
    display: flex;
    align-items: center;
    gap: 16px;
`;

export const OrganizationTag = styled('div')`
    display: flex;
    align-items: center;
    gap: 8px;
`;
